import { render, staticRenderFns } from "./LearnList.vue?vue&type=template&id=031b0f88&scoped=true&"
import script from "./LearnList.vue?vue&type=script&lang=js&"
export * from "./LearnList.vue?vue&type=script&lang=js&"
import style0 from "./LearnList.vue?vue&type=style&index=0&id=031b0f88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b0f88",
  null
  
)

export default component.exports